import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { motion } from "framer-motion";
import orgApi from "@/lib/orgApi";
import { getErrorMessage } from "@/lib/api";
import { Button, Card } from "@/components/studio/primitives";

/** Explicit confirmation prevents email scanners from consuming a single-use link. */
export default function OrgVerifyEmailPage() {
  const location = useLocation();
  const [token] = useState(() => new URLSearchParams(location.hash.slice(1)).get("token") || "");
  const [busy, setBusy] = useState(false);
  const [verified, setVerified] = useState(false);
  const [error, setError] = useState("");
  async function confirm() {
    setBusy(true); setError("");
    try {
      await orgApi.post("/org/auth/email-verification/confirm", { token });
      setVerified(true);
      window.history.replaceState(null, "", window.location.pathname);
    } catch (failure) {
      setError(getErrorMessage(failure, "This verification link could not be confirmed. Try again or request a new link from organization setup."));
    } finally { setBusy(false); }
  }
  return <main data-theme="dark" className="min-h-screen studio-spotlight flex items-center justify-center p-6">
    <motion.div initial={{ opacity: 0, y: 16 }} animate={{ opacity: 1, y: 0 }} className="w-full max-w-md">
      <Card padding={32} className="space-y-6">
      <h1 className="font-serif text-2xl text-[var(--text-primary)]">{verified ? "Email verified" : "Verify your administrator email"}</h1>
      <p role="status" className="text-sm text-[var(--text-secondary)]">{verified ? "Your email is verified. Return to your organization to continue scheduling setup." : "Confirm your email address to continue setting up your organization’s scheduler. Your password stays the same."}</p>
      {!verified && token && <Button fullWidth disabled={busy} onClick={confirm} className="duration-200 active:scale-95">{busy ? "Verifying…" : "Verify email"}</Button>}
      {!verified && !token && <p role="alert" className="text-sm text-[var(--state-danger)]">Open the verification link from your email, or request a new one from organization setup.</p>}
      {error && <p role="alert" className="text-sm text-[var(--state-danger)]">{error}</p>}
      <Link to="/org/settings/schedule" className="block text-sm underline text-[var(--text-primary)]">Return to organization setup</Link>
      </Card>
    </motion.div>
  </main>;
}
